export class Evaluation {
  title: string;
  fields: string[];
  imgFile: string;
  alt: string;
}



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/models/evaluation.model.ts